<template>
  <div>
    <!-- <spinner :visible="loading"></spinner> -->
    <v-modal id="modal-edit-tag">
      <span slot="header">
        <div class="header">
          <div class="badge badge-info adv-tag" :style="computedStyle">
            <i class="fa-light" :class="model.faicon" />
            {{ model.cod || 'TAG' }}
          </div>
          <div class="reset">
            <a style="color: white" href="#" @click="reset">{{ i18nJS.command.reset }}</a>
          </div>
        </div>
      </span>

      <div class="flex" id="cod-input-wrapper">
        <label class="text" for="cod">{{ i18nJS.label }}</label>
        <input name="cod" ref="modal-cod" v-model="model.cod" />
        <compact-picker v-model="model.fillcolor" />
      </div>

      <font-awesome-picker v-on:selectIcon="onIconSelected" :seachbox="i18nJS.search"></font-awesome-picker>

      <template slot="footer">
        <button class="btn btn-success" @click="save" :disabled="!saveable">{{ i18nJS.save }}</button>
      </template>
    </v-modal>

    <tree :options="treeOptions" ref="tree" :v-if="generated">
      <div slot-scope="{ node }" class="node-container" :key="node.id">
        <div class="node-controls" :class="{ link: node.id < 1 }">
          <a v-if="node.data.editable && can_delete" href="#" @click.stop="removeNode(node)"> <i class="fa-light fa-trash red"></i></a>
          <a v-if="node.data.editable && can_edit" href="#" @click.stop="addChildNode(node)">
            <i class="fa-light fa-folder-tree green"></i
          ></a>
          <div class="node-text badge badge-info" :style="nodeStyle(node)">
            <i class="tag-icon fa-light" :class="node.data.faicon || 'fa-tag'" v-if="node.id > 0" />
            {{ node.text }}
            <span class="count" v-if="nodecount != null">{{ nodecount[node.id] || 0 }}</span>
          </div>

          <i class="node-created-from">({{ node.data.business_unit_name }})</i>
        </div>
      </div>
    </tree>
    <div class="btn btn-navigation active" v-if="can_add">
      <a style="color: white" @click="newRootTag">{{ i18nJS.command.add }} TAG</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LiquorTree from 'liquor-tree';
import { Compact } from 'vue-color';
import fontAwesomePicker from 'font-awesome-5-picker';

import vModal from '../vModal';

export default {
  name: 'tags',
  props: {
    additional_params: { type: String, default: '' },
    business_unit_id: { type: Number, required: true },
    resource: { type: String, required: true },
    delconf: { type: String },
    gpds_id: { type: [Number, String] },
    tagname: { type: String, default: 'cod' },
    node_count: { type: Object, default: null },
    can_add: { type: Boolean },
    can_edit: { type: Boolean },
    can_delete: { type: Boolean },
  },
  data() {
    return {
      editingModel: undefined,
      nodecount: {},
      model: {
        id: null,
        cod: '',
        fillcolor: { hex: '#3a87ad' },
        faicon: 'fa-tag',
      },
      node: null,
      faicon: '',
      loading: true,
      generated: false,
      tags: [],
      treeOptions: {
        deletion: true,
        propertyNames: {
          text: 'cod',
        },
        parentSelect: true,
        // dnd: true,
        minFetchDelay: 1000,
        fetchData: `/${window.locale}/business_units/${this.business_unit_id}/tags/${this.resource}.json${this.additional_params}`,
      },
    };
  },
  components: {
    [LiquorTree.name]: LiquorTree,
    'compact-picker': Compact,
    vModal,
    fontAwesomePicker,
  },
  computed: {
    computedStyle() {
      return this.nodeStyle({ data: { fillcolor: { hex: this.model?.fillcolor?.hex } } });
    },
    deleteTagUrl() {
      return `/${window.locale}/business_units/${this.business_unit_id}/tags/__ID__.json`;
    },
    i18nJS() {
      return window.i18nJS;
    },
    icon() {
      return this?.model?.faicon || 'fa-tag';
    },
    resourceClass() {
      var resourceCam = Utils.camelize(this.resource);
      return resourceCam.charAt(0).toUpperCase() + resourceCam.slice(1);
    },
    saveable() {
      return this.model.cod && this.model.fillcolor && this.model.faicon;
    },
    tagsUrl() {
      return `/${window.locale}/business_units/${this.business_unit_id}/tags`;
    },
  },
  mounted() {
    this.nodecount = { ...this.node_count };
    this.$refs.tree.$on('node:selected', this.clickOnNode);
    eventBus.$on('tags_count_changes', this.updatesNodeCount);
    eventBus.$on('tags_count_recalc', this.changeNodeCount);
    eventBus.$on('removedDoc', this.decrementTotalCount);
  },
  methods: {
    reset() {
      this.model.fillcolor.hex = '#3a87ad';
      this.model.faicon = 'fa-tag';
    },
    onIconSelected(selectedIcon) {
      this.model.faicon = `fa-${selectedIcon.className}`;
    },
    nodeStyle(node) {
      const color = node.data?.fillcolor?.hex;
      if (color) {
        return `background-color: ${color}`;
      } else {
        return null;
      }
    },
    save() {
      const method = this.model.id ? 'put' : 'post';
      const url = this.model.id ? `${this.tagsUrl}/${this.model.id}` : this.tagsUrl;
      let data = { cod: this.model.cod, fa_icon: null, fillcolor: null };
      if (this.model.faicon !== 'fa-tag') {
        data['fa_icon'] = this.model.faicon;
      }
      if (this.model.fillcolor.hex !== '#3a87ad') {
        data['fillcolor'] = this.model.fillcolor.hex;
      }
      if (this.model.parent_id) {
        data['parent_id'] = this.model.parent_id;
      }
      if (!this.model.id) {
        data['resource'] = this.resourceClass;
        data['business_unit_id'] = this.business_unit_id;
      }
      axios({
        method: method,
        url: url,
        data: data,
        headers: {
          'Content-type': 'application/json',
          'X-CSRF-Token': $.rails.csrfToken(),
        },
      })
        .then((res) => {
          Utils.appendToFlash('success', '👍');
          if (!this.model.id) {
            (this.parent_node || this.$refs.tree).append({
              text: this.model.cod,
              id: res.data.id,
              state: { selected: true },
              data: { faicon: this.model.faicon, fillcolor: this.model.fillcolor },
            });
          } else {
            this.node.text = this.model.cod;
            this.node.data.fillcolor.hex = this.model.fillcolor.hex || '#3a87ad';
            this.node.data.faicon = this.model.faicon || 'fa-tag';
          }
          $('#modal-edit-tag').modal('hide');
        })
        .catch((err) => {
          var msg = `${i18nJS.errors.critical_error}: ${err.message} - ${err.response.data}`;
          if (err.response.status === 401) {
            msg = i18nJS.access_denied;
          }
          if (err.response.status === 422) {
            msg = err.response.data[0];
          }
          Utils.appendToFlash('error', msg);
        });
    },
    newRootTag() {
      this.model.cod = '';
      this.model.fillcolor.hex = '#3a87ad';
      this.model.faicon = 'fa-tag';
      this.model.id = null;
      this.model.parent_id = null;
      this.parent_node = null;
      this.node = null;
      $('#modal-edit-tag').modal('show');
    },
    addChildNode(node) {
      if (node.enabled()) {
        this.model.cod = '';
        this.model.fillcolor.hex = '#3a87ad';
        this.model.faicon = 'fa-tag';
        this.model.id = null;
        this.model.parent_id = node.id;
        this.parent_node = node;
        this.node = null;
        $('#modal-edit-tag').modal('show');
      }
    },
    editNode(node, e) {
      if (node.enabled()) {
        this.model.cod = node.text;
        this.model.fillcolor.hex = node.data.fillcolor.hex || '#3a87ad';
        this.model.faicon = node.data.faicon || 'fa-tag';
        this.model.id = node.id;
        this.model.parent_id = node.parent_id;
        this.node = node;
        $('#modal-edit-tag').modal('show');
      }
    },
    decrementTotalCount(data) {
      this.nodecount[-1] -= 1;
    },
    updatesNodeCount(data) {
      for (const id of data.remove) {
        this.nodecount[id] = this.nodecount[id] - 1;
      }
      for (const id of data.add) {
        if (this.nodecount[id]) {
          this.nodecount[id] += 1;
        } else {
          this.nodecount[id] = 1;
        }
      }
      this.nodecount = { ...this.nodecount };
    },
    changeNodeCount(data) {
      this.nodecount = data;
    },
    clickOnNode(node) {
      this.can_edit ? this.editNode(node) : this.dispatchSelectionEvent(node);
    },
    dispatchSelectionEvent(node) {
      const data = {
        id: node.id,
        gpds_id: this.gpds_id,
        text: node.text,
        time: new Date(),
      };
      eventBus.$emit('clickOnTag', data);
      var event = new CustomEvent('clickOnTag', {
        detail: data,
        bubbles: true,
        cancelable: true,
      });
      document.dispatchEvent(event);
    },
    removeNode(node) {
      if (node.enabled() && confirm(this.delconf.replace(/__TAG__/, node.text))) {
        axios({
          method: 'delete',
          url: this.deleteTagUrl.replace('__ID__', node.id),
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((res) => {
            Utils.appendToFlash('success', '👍');
            node.remove();
          })
          .catch((err) => {
            var msg = `${i18nJS.errors.critical_error}: ${err.message}`;
            if (err.response.status === 401) {
              msg = i18nJS.access_denied;
            }
            if (err.response.status === 422) {
              msg = err.response.data[0];
            }
            Utils.appendToFlash('error', msg);
          });
      }
    },
  },
};
</script>

<style lang="scss">
#iconPicker {
  max-width: inherit !important;

  div.iconPicker__header {
    padding: 0.8em;

    & > input {
      max-width: inherit;
    }
  }

  & > .iconPicker__header input {
    width: 97%;
    padding: 5px;
    margin: 0;
  }

  & .iconPicker__icons .item {
    width: 20px;
    height: 20px;
    padding: 9px;
  }
}
</style>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
}

.node-controls {
  display: flex;
  border-radius: 50px;
  vertical-align: middle;

  &.link {
    border: none;

    .node-text {
      background-color: transparent;
      color: #767676;
      font-weight: normal;
    }
  }

  & > a {
    margin: auto;
    padding: 4px;
  }

  & .fa-light {
    margin: 5px;
  }

  & .fa-light.tag-icon {
    margin: 0 5px;
  }

  .node-created-from {
    font-size: 12px;
    margin-left: 4px;
    margin-top: 4px;
    color: #494646;
  }
}

.fa-plus.pulsante_comando {
  border: 0;
  margin-left: 1em;
}

.node-text {
  font-size: 1em;
  padding: 6px 4px 6px 4px;
  border-radius: 50px;
}

.count {
  border-radius: 20px;
  padding: 1px 7px;
  margin-left: 5px;
  background-color: #fff;
  color: #333;
}

label {
  margin-right: 10px;
}

input {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px #000 0.08%;
  transition:
    border linear 0.2s,
    box-shadow linear 0.2s;
  height: 1em;
  padding: 5px;
  margin: 0 15px 0 5px;
  width: 180px;
}

.reset {
  font-size: 0.7em;
  margin-right: 15px;

  &:before {
    content: '\f0e2';
    font-family: 'Font Awesome 6 Pro';
    margin-right: 5px;
  }
}

.adv-tag {
  padding-top: 8px;
}
</style>
